import {Component, Inject, OnInit} from '@angular/core';
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatListModule} from "@angular/material/list";
import {CommonModule, DatePipe} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {HttpService} from "../../services/http/http.service";

@Component({
  selector: 'sedi-dialog',
  templateUrl: './sedi-dialog.component.html',
  styleUrls: ['./sedi-dialog.component.scss'],
  standalone: true,
  imports: [MatRadioModule, MatDatepickerModule, MatListModule, CommonModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule],
})
export class SediDialog implements OnInit {

  telefono: any;
  fax: any;
  email: any;
  listaComuni: any;
  listaProvince: any;
  comune: any;
  provincia: any;
  sede: any;
  isCreateMode : boolean;
  invaildId : boolean;

  constructor(
    public dialogRef: MatDialogRef<SediDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public datepipe: DatePipe,
    private api: HttpService
  ) {
    this.sede = {
      "idSede": null,
      "descrizione": null,
      "indirizzo": null,
      "cap": null,
      "istatComune": null,
      "telefono": null,
      "fax": null,
      "email": null,
      "listaTelefoni": [],
      "listaFax": [],
      "listaEmail": [],
      "flAttivo": null,
      "idComune": null,
      "cmbProvincia": {
        "id": null,
        "descrizione": null,
        "ordinamento": null
      },
      "cmbComune": {
        "id": null,
        "descrizione": null,
        "ordinamento": null
      },
      "modifica": true
    }
  }

  ngOnInit(): void {
    this.getProvince();
    this.isCreateMode = !this.data.idSede;
  }

  validateIdField(): void {
    if(!this.sede.idSede) {
      this.invaildId = false;
      return;
    }

    const incomingIdSede : string = `${this.sede.idSede}`;
    this.invaildId = incomingIdSede.length > 15;
    if (this.invaildId) {
      this.sede.idSede = null;
    }
  }

  getProvince(): void {
    this.api.getProvince().subscribe({
      next: (response: any) => {
        this.listaProvince = response.result;
      }
    })
  }

  getComuni(id: any): void {
    this.api.getComuni(id).subscribe({
      next: (response: any) => {
        this.listaComuni = response.result;
      }
    })
  }

  addTel(tel: any) {
    this.sede.listaTelefoni.push({ 'descrizione': tel });
  }
  addFax(fax: any) {
    this.sede.listaFax.push({ 'descrizione': fax });
  }
  addEmail(email: any) {
    this.sede.listaEmail.push({ 'descrizione': email });
  }

  removeTel(i: any) {
    this.sede.listaTelefoni.splice(i, 1);
  }
  removeFax(i: any) {
    this.sede.listaFax.splice(i, 1);
  }
  removeEmail(i: any) {
    this.sede.listaEmail.splice(i, 1);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  changeFlAttivo(e: any) {
    // this.data.details.flAttivo = e.value;
    this.sede.flAttivo = e.value;
  }

  handleSave(){
      this.dialogRef.close(this.sede);
  }

  saveIsDisabled () {
    let isDisabled;

    isDisabled = (!(this.sede && this.sede.idSede && this.sede.descrizione &&
      this.sede.cmbProvincia && this.sede.cmbProvincia.id &&
       this.sede.cmbComune && this.sede.cmbComune.id &&
      this.sede.indirizzo  &&
      this.sede.flAttivo));

    return isDisabled;
  }
}
